import { Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import localStorageKey from "../../enumerations/localStorageKey";
import { useCheckIfHiddenStore } from "../../hooks/HiddenStore/hiddenstore.hooks";
import { scrollToElementById } from "../../plugins/scrollFunction";
import DeviceArea from "./components/DeviceArea";
import ProductArea from "./components/ProductArea";
import StepsArea from "./components/StepsArea";
import TopArea from "./components/TopArea";
import styles from "./style.module.scss";

const HiddenStore = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [storeCode, setStoreCode] = useState(searchParams.get("store") ?? "");
  const [promoteCode, setPromoteCode] = useState(searchParams.get("code"));
  const { data: checkStore, isFetching: checkIsFetching } =
    useCheckIfHiddenStore({ code: storeCode }, { enabled: !!storeCode });

  useEffect(() => {
    if (
      !storeCode ||
      (checkStore?.discount_type === 0 && checkStore?.discount_value === 0)
    ) {
      window.localStorage.removeItem(localStorageKey.STORE_CODE);
      navigate("/");
      return;
    }

    if (checkStore) {
      window.localStorage.setItem(localStorageKey.STORE_CODE, storeCode);
    }
  }, [storeCode, checkStore]);

  useEffect(() => {
    if (location?.state?.area) {
      scrollToElementById(location.state.area);
    }
  }, [location]);

  useEffect(() => {
    if (promoteCode) {
      window.localStorage.setItem(localStorageKey.PROMOTE_CODE, promoteCode);
    }
  }, [promoteCode]);

  return (
    <Spin spinning={checkIsFetching}>
      <div className={styles.HiddenStoreContainer}>
        <TopArea />
        {storeCode && checkStore ? <ProductArea code={storeCode} /> : <></>}
        <DeviceArea />
        <StepsArea />
      </div>
    </Spin>
  );
};

export default HiddenStore;
